<template>
  <v-card
    @click="$emit('view', poll)"
    class="custom-card poll-card d-flex flex-column h-100"
  >
    <!-- HEADER -->
    <v-card-text class="pa-4 pb-2">
      <div class="d-flex justify-space-between align-start">
        <!-- Title + Description -->
        <div class="flex-grow-1">
          <span class="text-h6 font-weight-semibold mb-1">
            {{ poll.title }}
          </span>

          <p class="text-body-2 text-medium-emphasis mb-2">
            {{ poll.description || "No description available" }}
          </p>
        </div>

        <!-- Status (Top Right) -->
        <div>
          <v-chip
            class="text-capitalize"
            size="small"
            variant="tonal"
            :color="statusColor"
          >
            {{ poll.poll_status.toLowerCase() }}
          </v-chip>
        </div>
      </div>
    </v-card-text>

    <!-- BODY (Stats + Meta) -->
    <v-card-text class="flex-grow-1">
      <!-- Votes -->
      <div class="d-flex align-center justify-space-between mb-2">
        <div class="d-flex align-center">
          <v-icon
            color="primary"
            size="18"
            class="mr-1"
            icon="mdi-poll"
          ></v-icon>
          <span class="text-body-2 font-weight-medium">
            {{
              Object.values(poll.vote_counts).reduce((sum, val) => sum + val, 0)
            }}
            votes
          </span>
        </div>
      </div>

      <!-- Created Date -->
      <div class="text-h6 text-caption text-medium-emphasis">
        Created:
        {{
          new Date(poll.created_at).toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
          })
        }}
      </div>
    </v-card-text>

    <!-- ACTIONS -->
    <div class="mt-auto">
      <v-divider></v-divider>

      <v-card-actions class="px-4 py-2 justify-space-between">
        <v-btn
          variant="text"
          :color="poll.poll_status === 'ACTIVE' ? 'warning' : 'success'"
          size="small"
          :prepend-icon="
            poll.poll_status === 'ACTIVE'
              ? 'mdi-shield-off-outline'
              : 'mdi-shield-check-outline'
          "
          @click.stop="activateDeactivateMethod('status', poll)"
        >
          {{ poll.poll_status === "ACTIVE" ? "Deactivate" : "Activate" }}
        </v-btn>

        <v-btn
          variant="text"
          color="error"
          size="small"
          :disabled="poll.poll_status === 'ACTIVE'"
          prepend-icon="mdi-delete"
          @click.stop="activateDeactivateMethod('delete', poll)"
        >
          Delete
        </v-btn>
      </v-card-actions>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "PollCard",
  props: {
    poll: {
      type: Object,
      required: true,
    },
  },
  computed: {
    statusColor() {
      const colors = {
        ACTIVE: "success",
        INACTIVE: "warning",
        ARCHIVED: "error",
      };
      return colors[this.poll.poll_status] || "secondary";
    },
  },
  methods: {
    activateDeactivateMethod(action, poll) {
      this.$emit("clicked", action, poll);
    },
  },
};
</script>

<style scoped>
.poll-card {
  border-radius: 12px;
  transition: 0.2s ease;
}

.poll-card:hover {
  transform: translateY(-2px);
}

.text-semibold {
  font-weight: 600;
}

.text-muted {
  color: #888888;
}

.text-sm {
  font-size: 0.9rem;
}

.gap-2 {
  gap: 8px;
}
</style>
